import { all, call, put, takeLatest } from "redux-saga/effects";
import { setCustomerList, setCustomerSearchList, setListLoading } from "./reducer";
import { getCustomersList } from "services/authServices";
import { addToast } from "store/toaster/reducer";
import { TOAST_TYPES } from "enum/enums";
import { handleErrorMessage } from "lib/utils";
import { CUSTOMER_LIST } from "./action.types";




function*  fetchCustomersList(action:{type:string,payload:string}):Generator {
    yield put(setListLoading(true));
    try {
      const res:any = yield call(getCustomersList,action.payload);
      const uniqueStores = [...new Map(res?.data.stores.map((store:any) => [store.customerId, store])).values()];
      yield all([put(setCustomerList(uniqueStores)),put(setCustomerSearchList(uniqueStores)) ])
    } catch (error) {
      yield put(addToast({type:TOAST_TYPES.ERROR,messsage: handleErrorMessage(error)}));
    } finally {
      yield put(setListLoading(false));
    }
  }




function* customerSaga() {
    yield takeLatest(CUSTOMER_LIST, fetchCustomersList);

  }
export default customerSaga